import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette, SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      width: '100%',
      background: theme.palette.secondary.light,
      [theme.breakpoints.up('md')]: {
        width: 900,
      },
      '&:focus': {
        outline: 'none',
      },
    },
    headerWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: SMALL_MARGIN,
    },
    title: {
      fontSize: 24,
      lineHeight: 1.2,
      fontWeight: 'bold',
      marginBottom: 0,
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
      },
    },
    closeIcon: {
      width: 14,
      height: 14,
      cursor: 'pointer',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    certificateImgWrapper: {
      flex: 1,
      position: 'relative',
      marginBottom: SMALL_MARGIN,
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        marginRight: SMALL_MARGIN,
        marginBottom: 0,
      },
    },
    relativeWrapper: {
      position: 'relative',
      width: '100%',
      paddingTop: '52%',
    },
    certificateImgWrapperWithBg: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background: colorsPalette.violetAnalyticsCard,
      borderRadius: 5,
    },
    certificateImg: {
      borderRadius: 5,
      width: '100%',
    },
    buttonsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'stretch',
      '& button, & a': {
        marginBottom: 6,
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
    shareButtonWrapper: {
      '&:focus': {
        outline: 'none',
      },
    },
    shareButton: {
      cursor: 'pointer',
      marginBottom: 6,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    teamsShareOriginal: {
      display: 'none',
    },
  }),
);

export default useStyles;
